import { ModuleLocalization } from 'types'
import en from './en'

export const namespace = 'marlinsEnglishTestDetails'

export const localization: ModuleLocalization = { namespace, en }
